<template>
    <div id="app">
        <transition name="fade" mode="out-in">
            <Error v-if="error" :error="error"/>
            <Loading v-else-if="loading"/>
            <App v-else/>
        </transition>
    </div>
</template>
<script>
import { App, Error, Loading } from '.';
import { CoreConsumer } from '../../mixins';

export default {
    components: { App, Error, Loading },
    mixins: [CoreConsumer],
};
</script>
<style lang="scss" scoped>
#app {
    display: flex;
    flex-direction: column;
    min-height: 100%;
}
</style>
